// Description: Modal that allow the user to choose one list
// Updated: 26/09/2025
// Author: Simon Franklin

// React
import React from 'react'

// Material UI Components
import { CloseOutlined } from '@mui/icons-material'
import { Modal, Box, Button } from '@mui/material'

// Components and Functions for the project
import { DataGrid } from '@mui/x-data-grid'
import themeColors from '../../../components/ThemeColors/ThemeColors'
import Titles from '../../../components/Titles/Titles'
import { useNavigate } from 'react-router-dom'

const ListsModal = ({ open, onClose, lists, updateFieldValue, title, field, setError, activeColumns, formState, currentStep }) => {

    const [selectedRows, setSelectedRows] = React.useState([]);
    const [columnVisibilityModel, setColumnVisibilityModel] = React.useState({});
    const activeRows = (lists || []);
    const navigate = useNavigate();

    const handleRedirect = () => {
        sessionStorage.setItem("formState", JSON.stringify(formState))
        sessionStorage.setItem("currentStep", JSON.stringify(currentStep))
        sessionStorage.setItem("creating_campaign", JSON.stringify(true))
        navigate("/listagens/adicionar");
    }

    return (
        <Modal
            onClose={onClose}
            open={open}
            sx={{ '& .MuiBackdrop-root': { display: "none" } }}
        >
            <Box sx={{ backgroundColor: "#FFF", width: "100vw", height: "100vh", padding: "60px 40px 0px", maxHeight: "100vh", display: "flex", flexDirection: "Column" }}>
                <div onClick={onClose} style={{ cursor: 'pointer' }}>
                    <CloseOutlined
                        sx={{
                            color: themeColors.gray40,
                            display: 'block',
                            position: 'absolute',
                            top: { xs: '10px', sm: '30px' },
                            right: { xs: '10px', sm: '30px' },
                        }}
                    />
                </div>

                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Titles type="H2" children={title} color={themeColors.purple500} styles={{ marginBottom: "30px" }} />

                    <Button
                        variant='contained'
                        style={{ color: '#fff', width: '200px', padding: '10px', display: title === "Selecione uma listagem" ? "block" : "none" }}
                        onClick={() => handleRedirect()}
                    >
                        Importar Listagem
                    </Button>
                </Box>
                <DataGrid
                    rows={activeRows}
                    columns={activeColumns}
                    checkboxSelection
                    rowSelectionModel={selectedRows}
                    disableMultipleRowSelection={true}
                    onRowSelectionModelChange={(ids) => {
                        setError((prev) => ({
                            ...prev,
                            [field]: false
                        }));
                        setSelectedRows(ids)
                    }}
                    columnVisibilityModel={columnVisibilityModel}
                    onColumnVisibilityModelChange={(model) =>
                        setColumnVisibilityModel(model)
                    }
                    initialState={{
                        pagination: { paginationModel: { pageSize: 25, page: 0 } },
                        density: "comfortable",
                    }}
                    getRowClassName={(params) =>
                        params.row.Visibility === "Oculto" ? "row-oculto" : ""
                    }
                    sx={{
                        backgroundColor: "#FFF",
                        "& .row-oculto": {
                            backgroundColor: "#fffbea",
                        },
                        "& .MuiDataGrid-root": {
                            maxHeight: "calc(100% - 80px)"
                        },
                        flex: 1
                    }}
                />

                <div style={{ display: "flex", gap: "16px", marginTop: "22px", minWidth: "100%", justifyContent: "flex-end", paddingBottom: "20px" }}>
                    <Button onClick={() => setSelectedRows([])} variant="outlined" sx={{ width: "81px", height: "39px", padding: "10px" }}>
                        Cancelar
                    </Button>
                    <Button onClick={() => {
                        updateFieldValue(field, selectedRows[0]);
                        onClose();
                    }} variant="contained" sx={{ width: "81px", height: "39px", padding: "10px" }}>
                        Selecionar
                    </Button>
                </div>
            </Box>
        </Modal>
    )
}

export default ListsModal